import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const Sidebar = styled('div')`
  background-color: var(--dark-blue);
  margin-top: -1px;

  &.horizontal {
    position: absolute;
    top: 0;
    bottom: 0;
    max-width: 62px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  &.expanded {
    max-width: none;
    width: 215px;

    div[class*='SidebarLogo'] {
      width: 215px;
      height: 65px;
      margin: 0;
    }

    span {
      display: inline-block;
    }

    div[class*='SidebarLogoVersion'] {
      display: block;
    }

    div[class*="SidebarExpand"] {
      right: 0;
      top: 19px;
    }

    div[class*="SidebarDivider"] {
      margin: 12px -10px 10px 0;
    }
  }
`;

const SidebarLogo = styled(Svg)`
  background-color: var(--white);
  width: 62px;
  height: 65px;
  padding: 0;
`;

const SidebarDivider = styled('div')`
  margin: 14px -10px 10px 0;
`;

const SidebarExpand = styled('div')`
  transition: var(--ph-transition);
  position: absolute;
  top: 19px;
  right: 4px;
  width: 15px;
  height: 26px;
  cursor: pointer;
  z-index: 100;

  &::before {
    content: '';
    border: solid #dbdbdb;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(-45deg);
    position: absolute;
    left: 8px;
    top: 9px;
  }

  &:hover {
    &::before {
      border-color: #29a9e0;
    }
  }

  &.expanded {
    transform: rotate(180deg);

    &::before {
      left: 8px;
      top: 9px;
    }
  }
`;

const SidebarLogoVersion = styled('div')`
  display: none;
  color: #788da3;
  font-size: var(--ph-text-xs);
  font-stretch: normal;
  font-style: normal;
  position: absolute;
  bottom: 2px;
  left: 2px;
`;

export default {
  Sidebar,
  SidebarLogo,
  SidebarDivider,
  SidebarExpand,
  SidebarLogoVersion,
};
